export const appRoutes = {
  assessementKit: {
    createAssessment: "/assessment/create-assessment",
    viewAssessment: "/assessment/create-assessment/:id",
    viewCandidates: "/assessment/view-candidates/:id",
    editAssessment: "/assessment/create-assessment/:id",
    allAssessments: "/assessment/assessment-kits",
    assessmentPublicDetails: "/assessment/assessment-details/:id",
    previewAssessment: "/assessment/preview/:assignedAssessmentId",
    takeAssessment: "/assessment/assessment-screen/:assignedAssessmentId",
    candidateAssessmentView:
      "/assessment/candidates-assessment-response/:assessmentId",
    candidateAssignedAssessments: "/assessment/candidate-assigned-assessments",
    assignedAssessmentDetail: "/assessment/assigned-assessment-detail/:assessmentId",
    scheduleEventLink: "/schedule-interview",
    mentorProfile: "/mentor-profile/",
    candidateProfile: "/view-candidate-profile/"
  },
};
